import CloseIcon from "@mui/icons-material/Close";
import { Button, IconButton, Input } from "@mui/material";
import TextField from "@mui/material/TextField";
import React, { useEffect, useState } from "react";
import PhoneInput from "react-phone-input-2";
import { useNavigate } from "react-router-dom";

import "react-phone-input-2/lib/bootstrap.css";

import { showToast } from "../../helpers/showToast";
import useAuth from "../../hooks/useAuth";
import MainContainer from "../../layout/MainContainer";
import { usePostSetProfileMutation } from "../../service/auth";
import { CommonBody } from "../../types/General";
import { generateEncryptedKeyBody } from "../../utils/crypto";
import { UploadMedia } from "../../utils/mediaUpload";
import { isValidInput } from "../../utils/validations";

const MyProfile = () => {
  const user = useAuth();
  const navigate = useNavigate();

  const [updateProfile] = usePostSetProfileMutation();

  const [profileImage, setProfileImage] = useState("");
  const [fullName, setFullName] = useState(user?.name || "");
  const [email, setEmail] = useState(user?.email || "");
  const [phone, setPhone] = useState(user?.phoneNo || "");
  const [dialCode, setDialCode] = useState(user?.dialCode || "");
  const [submitted, setSubmitted] = useState(false);

  const handleChangePhone = (phone: any, country: any) => {
    setPhone(phone?.replace(country.dialCode, ""));
    setDialCode(country?.dialCode);
  };

  const handleProfileUpload = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const files = event.target.files;
    const file = files?.length ? files[0] : null;

    if (!file) {
      setProfileImage("");
      return;
    }

    console.log(file, "file");

    const imageUrl = (await UploadMedia(file)) as any;
    if (imageUrl?.data?.image) {
      setProfileImage(imageUrl?.data?.image || "");
    }
  };

  const onSubmit = async () => {
    setSubmitted(true);

    if (!fullName?.length) {
      return;
    }
    if (!phone?.length) {
      return;
    }

    const body = {
      phone: phone,
      email,
      firstName: fullName,
      image: profileImage,
      countryCode: dialCode,
    };
    try {
      const encryptedBody = generateEncryptedKeyBody(body) as CommonBody;
      const response = await updateProfile(encryptedBody).unwrap();
      if (response?.statusCode === 200) {
        showToast("Profile updated successfully");
        navigate("/dashboard");
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (user) {
      setFullName(user?.firstName || "");
      setEmail(user?.email || "");
      setPhone(user?.phone || "");
      setProfileImage(user?.image || "");
      setDialCode(user?.countryCode || "");
    }
  }, [user]);

  return (
    <MainContainer>
      <div className="main_title fdx">
        <div>
          <h1>My Profile</h1>
          <p>
            <span onClick={() => navigate("/dashboard")}>Dashboard</span> - My
            Profile
          </p>
        </div>
        <div className="right_s align_right">
          <Button className="btn btn_orange" onClick={() => navigate(-1)}>
            Back
          </Button>
        </div>
      </div>

      <div className="cards">
        <form className="form">
          <div className="gap_p">
            <div className="control_group w_100">
              <label>Profile Image</label>
              <div className="upload_box">
                <label>
                  {profileImage && (
                    <IconButton
                      className="crossIcon"
                      onClick={() => setProfileImage("")}
                    >
                      <CloseIcon />
                    </IconButton>
                  )}
                  <figure>
                    <img
                      src={
                        profileImage
                          ? profileImage
                          : "/static/images/user_placeholder.png"
                      }
                      alt="Upload"
                    />
                  </figure>
                  <IconButton className="uploadIcon">
                    <label htmlFor="icon-button-file">
                      <Button component="span" className="upload_image_btn">
                        <img src="/static/images/edit2_icon.svg" alt="Upload" />
                        <Input
                          sx={{ display: "none" }}
                          id="icon-button-file"
                          type="file"
                          inputProps={{
                            accept: "image/png,image/jpeg",
                          }}
                          onChange={(e: any) => {
                            handleProfileUpload(e);
                            e.target.value = null;
                          }}
                        />
                      </Button>
                    </label>
                  </IconButton>
                </label>
              </div>
            </div>
            <div className="control_group w_50">
              <label>Full Name</label>
              <TextField
                variant="outlined"
                placeholder="Full Name"
                fullWidth
                hiddenLabel
                value={fullName}
                onChange={(val) => {
                  if (isValidInput(val.target.value)) {
                    setFullName(val.target.value);
                  }
                }}
                FormHelperTextProps={{ color: "red" }}
              />
              <p className="err_msg">
                {submitted && !fullName?.length ? "Full Name is required" : ""}
              </p>
            </div>

            <div className="control_group w_50">
              <label>E-mail</label>
              <TextField
                variant="outlined"
                placeholder="Enter here"
                fullWidth
                disabled
                hiddenLabel
                value={email}
                onChange={(val) => {
                  if (isValidInput(val.target.value)) {
                    setEmail(val.target.value);
                  }
                }}
              />
            </div>
            <div className="control_group w_50">
              <label>Phone Number</label>
              <PhoneInput
                enableSearch
                value={dialCode + phone}
                country={"uae"}
                inputClass="phoneInput"
                onChange={(phone, country) => handleChangePhone(phone, country)}
                inputStyle={{ width: "100%" }}
                buttonClass="phoneBtn"
                placeholder="Phone Number"
              />
              <p className="err_msg">
                {submitted && !phone?.length ? "Phone number is required" : ""}
              </p>
            </div>
          </div>
          <div className="form_btn end">
            <Button className="btn btn_secondary" onClick={onSubmit}>
              Save Changes
            </Button>
          </div>
        </form>
      </div>
    </MainContainer>
  );
};

export default MyProfile;
